<!--
 * @Author: MouXiaowei
 * @Date: 2022-05-26 14:24:02
 * @Description: 邮储银行数字人民币红包活动-分享页
-->
<template>
  <div class="home-box">
    <div class="bjqd-btn">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_bjqd_btn1_green.png" @click="goApp">
    </div>
    <div class="tip-box">
        <p class="tip-box-title">温馨提示：</p>
        <p class="tip-box-value">1.红包到账情况可通过数字人民币APP查看，请在有效时间内使用。</p>
        <p class="tip-box-value">2.近期少数不法分子以“数字人民币交易所”、“获利”、“返现”、“分红”为名进行诈骗。请警惕仿冒APP和仿冒银行信息，谨防不法分子冒充银行和公安机关工作人员骗取信息。</p>
    </div>
    <div class="introduce-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_introduce2_green.png">
    </div>
    <div class="explain-box">
        <div class="explain-box-desc">
            <p>1.红包活动报名</p>
            <p>“新客”下载并注册最新版本的便捷青岛APP，点击“邮储银行100万数字人民币红包”活动页面参与活动报名。</p>
            <p>2.下载数字人民币APP，注册开通邮储银行数币钱包领取红包</p>
        </div>
        <div class="explain-box-btn">
            <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_detail_btn1_green.png" @click="gotoOpenExplainPage">
        </div>
        <p>3.领取活动红包并使用</p>
        <div class="explain-box-btn">
            <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_detail_btn1_green.png" @click="gotoRedpaperExplainPage">
        </div>
    </div>
    <div class="rule-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_rule2_green.png">
    </div>
    <div class="logo-box">
        <img src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_logo2.png">
    </div>
    <share-sheet :showShare="showShare" @share="handleShareContent" @cancleShare="handleCancelShare"></share-sheet>
  </div>
</template>
<script>

export default {
  components: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    gotoOpenExplainPage () {
      this.$router.push('/psbcOpenExplain')
    },
    gotoRedpaperExplainPage () {
      this.$router.push('/psbcRedparperExplain')
    },
    // 跳转便捷青岛APP
    goApp () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  background: #97D086 url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_bg2_green.png') no-repeat;
  background-size: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bjqd-btn {
    margin-top: 64%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.tip-box {
    margin: 15px 47px;
    font-size: 12px;
    color: #4B4B4B;
    line-height: 18px;
    &-title {
        margin-bottom: 8px;
        font-weight: bold;
        text-align: center;
    }
}
.introduce-box {
    margin-top: 14.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 336px;
    }
}
.explain-box {
    margin-top: 14.5px;
    height: 310px;
    width: 336px;
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/psbcActive/psbc_explain1_green.png') no-repeat;
    .explain-box-desc {
        padding-top: 51.5px;
    }
    p {
        margin-left: 15.5px;
        margin-right: 15.5px;
        font-size: 12px;
        color: #64B25C;
        letter-spacing: 0;
        line-height: 18px;
    }
    .explain-box-btn {
        margin-top: 11px;
        margin-bottom: 11px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
}
.rule-box {
    margin-top: 14.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 336px;
    }
}
.logo-box {
    margin-top: 44.5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    img {
        width: 100%;
    }
}
</style>
